import React from 'react';
import './countryPage.css';
import { Link } from 'react-router-dom';

const countries = [
  { name: 'United Kingdom', flag: 'https://flagcdn.com/gb.svg', link: 'form' },
  { name: 'United States', flag: 'https://flagcdn.com/us.svg', link: 'form' },
  { name: 'Canada', flag: 'https://flagcdn.com/ca.svg', link: 'form' },
  { name: 'Australia', flag: 'https://flagcdn.com/au.svg', link: 'form' },
  { name: 'New Zealand', flag: 'https://flagcdn.com/nz.svg', link: 'form' },
  { name: 'Europe', flag: 'https://flagcdn.com/eu.svg', link: 'form' },
  { name: 'Russia', flag: 'https://flagcdn.com/ru.svg', link: 'form' },
  { name: 'Switzerland', flag: 'https://flagcdn.com/ch.svg', link: 'form' },
  { name: 'Dubai', flag: 'https://flagcdn.com/ae.svg', link: 'form' },
  { name: 'Ireland', flag: 'https://flagcdn.com/ie.svg', link: 'form' },
  { name: 'Singapore', flag: 'https://flagcdn.com/sg.svg', link: 'form' },
  { name: 'Germany', flag: 'https://flagcdn.com/de.svg', link: 'form' },
];

const CountryPage = () => {
  return (
    <div className="page-container1">
      <h1 className="title">Countries We Work With</h1>
      <div className="country-grid">
        {countries.map((country, index) => (
          <Link to={`/${country.link}`} key={index} className="country-card">
            <img src={country.flag} alt={country.name} className="flag" />
            <h3>{country.name}</h3>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CountryPage;
